module.exports = __webpack_public_path__ + "static/img/book_a_demo.758b051a.png";